(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
  var mobileButton = document.getElementById('mobile-search-button');
  var mobileModal = document.getElementById('mobile-search-modal');
  var mobileClose = document.getElementById('mobile-search-close');
  var mobileInput = document.getElementById('mobile-search-input');

  // Open modal
  mobileButton.addEventListener('click', function() {
    mobileModal.style.display = 'block';
    mobileInput.focus();
  });

  // Close modal
  mobileClose.addEventListener('click', function() {
    mobileModal.style.display = 'none';
  });

  // Close modal if clicking outside content
  window.addEventListener('click', function(e) {
    if (e.target == mobileModal) {
      mobileModal.style.display = 'none';
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
